<template>
  <fragment>
    <template v-for="item in list">
      <v-list-group v-if="!item.to" :key="item.textkey" v-model="item.model" no-action :sub-group="subGroup">
        <template v-slot:activator>
          <v-list-item-action v-if="item.icon && !subGroup">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-title>{{ $t('language.' + item.textkey) }}</v-list-item-title>
        </template>
        <menu-list :list="getChildMenus(item.textkey)" :sub-group="true"></menu-list>
      </v-list-group>
      <v-list-item
        v-else
        :key="item.textkey"
        :to="item.to"
        active-class="general"
        class="v-list-item"
      >
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-title>
          {{ $t('language.' + item.textkey) }}
          <v-chip
            v-if="item.textkey == 'inbox' && $store.getters.inboxcount.total > 0"
            small
            class="float-right"
            color="red"
            text-color="white"
          >{{$store.getters.inboxcount.total}}</v-chip>
        </v-list-item-title>
      </v-list-item>
    </template>
  </fragment>
</template>
<script>
import { Fragment } from "vue-fragment";
export default {
  name:"menu-list",
  props: {
    list: {
      type: Array
    },
    subGroup:{
      type:Boolean
    }
  },
  components: {
    Fragment
  },
  methods: {
    getChildMenus(parentpagekey) {
      if (this.$store.getters.usermenu.length > 0) {
        return this.$store.getters.usermenu.filter(c => {
          return c.parentpagekey == parentpagekey;
        });
      } else return [];
    }
  }
};
</script>